/* eslint-disable extra-rules/no-commented-out-code */
// Message State constants
export var MESSAGE_STATE_NEW = "new";
export var MESSAGE_STATE_ACCEPT_ANSWER_PROMPT = "accept-answer-prompt"; // custConfirmation = true

export var MESSAGE_STATE_RATE_AMBASSADOR = "rate-ambassador"; // customerScore = <number> || !customerScore = <number> & captureCustomerReview = <boolean>

export var MESSAGE_CUSTOMER_OPINION_SCORE = "customer-opinion-score";
export var MESSAGE_CUSTOMER_OPINION_ACCEPT = "customer-opinion-accept";
export var MESSAGE_STATE_PENDING_CLOSURE = "pending-closure"; //accepted but not custResolved and not auto resolved

export var MESSAGE_STATE_CUSTOM = "pending-closure"; //accepted but not custResolved and not auto resolved

export var MESSAGE_STATE_CLOSED = "closed"; // state = closed

export var MESSAGE_STATE_SUGGESTED_ANSWER = "suggested-answer"; // last dialogue is suggested answer

export var MESSAGE_STATE_REPORTED = "reported"; // reportedAt || reportedNote || reportedReason

export var MESSAGE_STATE_TIMEDOUT = "timedout"; // state = closed & lifecycleState = timedout

export var MESSAGE_STATE_FORWARDED = "escalated"; // state = closed & lifecycleState = escalated

export var MESSAGE_STATE_RESOLVED = "resolved"; // state = closed & lifecycleState = resolved

export var MESSAGE_STATE_RATE_FINISH = "rate-and-finish";
export var MESSAGE_STATE_RERATE_YOUR_EXPERIENCE = "rerate-your-experience"; // accepted = true & others

export var MESSAGE_STATE_LOADING = "loading";